<div class="status-tracker">
  <div class="d-flex justify-content-between">
    <p class="description-title">
      <span translate>Status:</span>
      <b> {{ configuration.stageTitle || currentStatus || 'N/A' }}</b>
    </p>
    @if (configuration.showEstimatedTime) {
      <p class="delivery-time">
        <span translate>EST DELIVERY TIME :</span>
        <b>
          {{
            configuration?.estimatedDeliveryTime
              | serviceDate: 'MMM dd, yyyy | h:mm a'
              | numberTranslate
          }}
        </b>
      </p>
    }
  </div>

  <div class="row">
    <div class="col-sm-12">
      <div class="row bars-row">
        @for (stage of configuration?.stages; track stage) {
          <div class="col">
            <div
              class="progress"
              style="height: 8px"
              placement="bottom"
              [ngbTooltip]="stage.title"
            >
              <div
                class="progress-bar"
                [ngClass]="{
                  'progress-bar-striped progress-bar-animated in-progress-bar':
                    stage.progress === 1,
                }"
                role=" progressbar"
                [ngStyle]="{ width: stage.progress ? '100%' : 0 }"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
